export default (el, _binding, vnode) => {
    if (_binding.value !== undefined && !_binding.value) return

    const selectionStart = el.selectionStart

    let value

    const getOnlyDigits = value => value.replace(/\D+|-/g, '')

    if (el.tagName.toUpperCase() !== 'INPUT') {
        let input = el.getElementsByTagName('input')

        if (input.length !== 1) throw new Error('v-number directive requires input')
        else el = input[0]

        value = getOnlyDigits(vnode.componentInstance.value)
    } else {
        value = getOnlyDigits(vnode.elm.value)
    }

    if (el.value !== value) {
        el.value = value

        el.dispatchEvent(new Event('input'))
        el.setSelectionRange(selectionStart, selectionStart)
    }
}